window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.base = {
    headers: function () {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'RequestVerificationToken': casino.config.antiForgeryToken
        }
    },
    credentials: 'include',
    serializeGetParams: function (obj) {
        return '?' + Object.keys(obj).reduce(function (a, k) {
            a.push(k + '=' + encodeURIComponent(obj[k]));
            return a
        }, []).join('&')
    },
    checkResponse: function (response) {
        if (response.status !== 200) {
            throw response;
        }
        return response;
    },
    handleNetworkException: function (error) {
        // Ako je dokument skriven,ne trigeriramo fatalni error screen — ovo sprječava
        // "Greška u komunikaciji" kada se korisnik vrati u browser
        if (document.hidden) {
            console.warn('Network error ignored (document hidden):', error);
            return;
        }
        if (casino.repos.base.networkErrorsListener != null)
            casino.repos.base.networkErrorsListener(error);
    },
    networkErrorsListener: null
};